import { createApi } from '../createApi';
import * as dummy from '../dummy/members';
import * as real from '../api/members';

const api = createApi(dummy, real);

/** 회원 관리 서비스 — API_DOCS: 26. 관리자 - 회원 */
export const memberService = {
  getList: api.getMembers,
  getById: api.getMemberById,
  updateStatus: api.updateMemberStatus,
  delete: api.deleteMember,
  getReservations: api.getMemberReservations,
  getReviews: api.getMemberReviews,
};
